<template>
    <nav class="breadcrumb has-arrow-separator" aria-label="breadcrumbs">
        <ul>
            <li
                v-for="(item, index) in items"
                :key="'bc-'+index"
                :class="{ 'is-active': item.active }"
            >
                <router-link :to="item.to">{{ item.title }}</router-link>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    props: {
        items: Array,
    }
}
</script>
